export default "__VITE_ASSET__C$qazeCc__"